import { enableAccessSummaryUI } from '@gonfalon/dogfood-flags/dogfood-flags';

export function isAccessSummaryEnabled() {
  return enableAccessSummaryUI();
}
